/**
 * Expert profile helpers — Phase 5 replacement.
 * Delegates to /api/experts/* endpoints on dash-api instead of Firestore.
 */

import {getApiBase} from '../../config/apiBase';

function buildApiUrl(path) {
    const base = getApiBase();
    if (path.startsWith('/api/')) {
        return `${base}${path.slice(4)}`;
    }
    if (path.startsWith('/')) {
        return `${base}${path}`;
    }
    return `${base}/${path}`;
}

function authHeaders() {
    const token = localStorage.getItem('access_token');
    return token
        ? {'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json'}
        : {'Content-Type': 'application/json'};
}

async function apiFetch(path, opts = {}) {
    const resp = await fetch(buildApiUrl(path), {headers: authHeaders(), ...opts});
    if (resp.status === 404) return null;
    if (!resp.ok) throw new Error(`${opts.method || 'GET'} ${path} → ${resp.status}`);
    if (resp.status === 204) return null;
    return resp.json();
}

export const getExpertByHandle = async (handle) => {
    if (!handle) return null;
    return apiFetch(`/api/experts/by-handle/${encodeURIComponent(handle)}`);
};

export const getExpertByUid = async (uid) => {
    if (!uid) return null;
    return apiFetch(`/api/experts/by-uid/${encodeURIComponent(uid)}`);
};

export const getAllExperts = async () => {
    const data = await apiFetch('/api/experts');
    return Array.isArray(data) ? data : [];
};

export const getContributionCounts = async () => {
    const data = await apiFetch('/api/experts/contribution-counts');
    return data && typeof data === 'object' ? data : {};
};

export const subscribeToExperts = (onChange) => {
    let cancelled = false;
    getAllExperts()
        .then((data) => { if (!cancelled) onChange?.(data); })
        .catch((err) => { console.error('[experts] subscribeToExperts', err); if (!cancelled) onChange?.([]); });
    return () => { cancelled = true; };
};

export const subscribeToExpert = (handle, onChange) => {
    if (!handle) return () => {};
    let cancelled = false;
    getExpertByHandle(handle)
        .then((data) => { if (!cancelled) onChange?.(data); })
        .catch(() => { if (!cancelled) onChange?.(null); });
    return () => { cancelled = true; };
};

export const subscribeToExpertByUid = (uid, onChange) => {
    if (!uid) return () => {};
    let cancelled = false;
    getExpertByUid(uid)
        .then((data) => { if (!cancelled) onChange?.(data); })
        .catch((err) => { console.error('[experts] subscribeToExpertByUid', err); if (!cancelled) onChange?.(null); });
    return () => { cancelled = true; };
};

export const upsertExpertProfile = async (handle, data) => {
    if (!handle) throw new Error('handle is required');
    return apiFetch(`/api/experts/${encodeURIComponent(handle)}`, {
        method: 'PUT',
        body: JSON.stringify(data),
    });
};

export const updateExpertLlmFields = async (handle, {expertise, specialties, expertiseUpdatedAt}) => {
    if (!handle) throw new Error('handle is required');
    return apiFetch(`/api/experts/${encodeURIComponent(handle)}/llm-fields`, {
        method: 'PATCH',
        body: JSON.stringify({expertise, specialties, expertiseUpdatedAt}),
    });
};
